export default __webpack_public_path__ + "media/images/icon_public-638410c822c783f8ff21c07015a97c43.png";